import { css } from '@emotion/react';

export const wrapperStyle = () =>
  css({
    width: '100%',
    verticalAlign: 'top',
  });
